<!--
 * @Author: Gaho
 * @Date: 2024-06-14 15:13:37
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-28 11:12:56
 * @Description: Account-交易历史
-->
<template>
    <q-dialog class="game-dialog" full-width full-height :position="'top'" @hide="handleHide"
        style="background:#1c2532;" :transition-show="'slide-left'" :transition-hide="'slide-right'"
        :transition-duration="300" :model-value="show">
        <div class="account-history">
            <div class="w-[100vw] fixed top-0 left-0 z-10 bg-[#06080d] pb-[8px] px-[16px] pt-[16px] flex flex-nowrap items-center justify-between">
                <!-- Select 区域 -->
                <div class="history-select text-white">
                    <DatePicker v-model="datePicker" @update:model-value="handleDatePicker" />
                    <DropDown class="drop-down max-w-[70px]" v-model="actionValue" :options="accountHistoryActions"
                        @update:model-value="handleSelectAction" />
                </div>
                <q-btn class="popup-close" icon="close" color="white" flat round dense v-close-popup />
            </div>
            <div class="pt-[73px] px-[16px]">
                <!-- Table 区域 -->
                <div class="history-table" v-if="historyData?.response?.length">
                    <div class="table-header flex items-center">
                        <span v-for="item in columns" :key="item.field"
                            class="inline-block text-[#55657e] font-bold text-[11px] pl-[16px] cursor-pointer relative header-th truncate"
                            :style="`max-width: ${item?.maxWidth};min-width: ${item?.minWidth}`"
                            :class="`item-${item.field}-th`">
                            {{ item.label }}
                        </span>
                    </div>
                    <!-- 
                        ↑ 表头
                        ↓ 表格主体 
                    -->
                    <div class="table-body">
                        <ul>
                            <li v-for="(item, iRowIndex) in historyData?.response" :key="item.hash">
                                <div :style="`max-width: ${columns[0]?.maxWidth};min-width: ${columns[0]?.minWidth}`"
                                    class="font-semibold cursor-default w-full mr-[8px]"
                                    :class="`item-${columns[0].field}`">
                                    <ClientOnly>
                                    <Popper hover arrow placement="top" :style="oPopperStyle" class="w-full" v-if="windowWidth <= columns[0]?.showIconFrom">
                                        <span
                                            class=" w-[24px] h-[24px] flex items-center justify-center rounded-[8px] m-auto">
                                            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                                                class="text-[16px] w-[16px] h-[16px] text-[#a7b5ca]">
                                                <path fill="currentColor"
                                                    d="M18.33 8.6v7.07c0 1.77-.92 2.66-2.77 2.66H4.44c-1.85 0-2.77-.89-2.77-2.66V8.6c0-.15.12-.27.27-.27h16.12c.15 0 .27.12.27.27Zm-2.77-4.93H14.4V2.33a.69.69 0 0 0-.7-.66c-.38 0-.7.3-.7.66v1.34H7V2.33a.69.69 0 0 0-.7-.66c-.38 0-.7.3-.7.66v1.34H4.44c-1.85 0-2.77.89-2.77 2.66v.4c0 .15.12.27.27.27h16.12c.15 0 .27-.12.27-.27v-.4c0-1.77-.92-2.66-2.77-2.66Z">
                                                </path>
                                            </svg>
                                        </span>
                                        <template #content>
                                            <p class="flex flex-col bg-[#2a3546]">
                                                <span class="text-[12px] text-white">
                                                    {{ formatNewDate(item.date) }}
                                                </span>
                                                <span class="text-[11px] text-[#93acd3]">
                                                    {{ localeLang === 'cn' ? moment(item.date).format('HH:mm:ss') :
                                                        moment(item.date).format('hh:mm:ss A') }}
                                                </span>
                                            </p>
                                        </template>
                                    </Popper>

                                    <p class="flex flex-col" v-else>
                                        <span class="text-[12px] text-white">
                                            {{ formatNewDate(item.date) }}
                                        </span>
                                        <span class="text-[11px] text-[#93acd3]">
                                            {{ localeLang === 'cn' ? moment(item.date).format('HH:mm:ss') :
                                                moment(item.date).format('hh:mm:ss A') }}
                                        </span>
                                    </p>
                                    </ClientOnly>
                                </div>
                                <!-- ↓ 单元格操作类型 -->
                                <div class="text-[14px] font-bold cursor-default w-full truncate"
                                    :class="[`item-${columns[1].field}`, windowWidth < columns[0]?.showIconFrom && '!pl-0']"
                                    :style="{
                                        'max-width': columns[1]?.maxWidth,
                                        'min-width': columns[1]?.minWidth,
                                        'color': oActions[item.type]?.color,
                                    }">
                                    <IconSvgUse class="inline-block " :use="oActions[item.type]?.icon" size="20px" />
                                    <span class="align-middle pl-1">
                                        {{ oActions[item.type]?.name }}
                                    </span>
                                </div>
                                <div :style="`max-width: ${columns[2]?.maxWidth}; min-width: ${columns[2]?.minWidth}`"
                                    :class="`item-${columns[2].field} ${item.state === 'done' ? '!text-[#1BB83D]' : ''}`"
                                    class="cursor-default w-full truncate">
                                    <span class="state-span shrink-0" v-if="item.state === 'done'"
                                        :class="windowWidth <= columns[2]?.hideStatusTextFrom && '!p-0'">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                            class="text-[#1bb83d] inline">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M17.06 10.36c.47-.49.45-1.27-.05-1.73a1.24 1.24 0 0 0-1.74.05l-4.2 4.42-2.34-2.45a1.24 1.24 0 0 0-1.74-.06c-.5.47-.52 1.24-.05 1.74l3.23 3.39a1.24 1.24 0 0 0 1.79 0l5.1-5.36Z">
                                            </path>
                                        </svg>
                                    </span>
                                    <span class="state-span">
                                        {{ $t(item.state === 'done' ? 'Redeemed' : 'Redeeming') }}
                                    </span>
                                </div>
                                <!-- ↓ 最后一列：币种+金额信息 -->
                                <div :style="`max-width: ${columns[3]?.maxWidth}; min-width: ${columns[3]?.minWidth}`"
                                    class="pr-[10px] flex justify-between text-[14px] cursor-default w-full"
                                    :class="[`item-${columns[3].field}`, windowWidth > columns[2]?.hideStatusTextFrom && '!p-[8px]']">
                                    <p class="flex text-[14px] max-w-[100%] flex-nowrap">
                                        <CurrentCoin :name="item.currency" size="20px" class="mr-[.5em]" />
                                        <ClientOnly>
                                        <Popper hover arrow placement="top" :style="oPopperStyle" class="w-full"
                                            :key="iRowIndex">
                                            <CasinoWidgetColoredAmount class="font-semibold truncate inline "
                                                :class="{ 'plus-mark': item.amount > 0 }"
                                                :colors="[oActions[item.type]?.color, 'rgb(85,101,126)']"
                                                :amount="Number(getFixed(item.amount))" />
                                            <!--  -->
                                            <template #content>
                                                <CasinoWidgetColoredAmount class="font-semibold "
                                                    :class="{ 'plus-mark': item.amount > 0 }"
                                                    :colors="[oActions[item.type]?.color, 'rgb(85,101,126)']"
                                                    :amount="Number(getFixed(item.amount))" />
                                            </template>
                                        </Popper>
                                    </ClientOnly>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Pagination 区域 -->
                <div class="history-pagination" v-if="historyData?.response?.length">
                    <q-pagination v-model="params.page" :max="Math.ceil(historyData?.count / iRows)" :max-pages="4"
                        boundary-numbers color="[#55657e]" active-color="[#2281f6]" direction-links />
                </div>
                <Empty v-else>
                    <img width="134" height="132" src="@/assets/imgs/casino/no-data-image.webp" alt="">
                </Empty>
            </div>
        </div>
    </q-dialog>
</template>

<script lang="ts">
import Popper from "vue3-popper";
import { defineComponent, onUnmounted } from 'vue';
import moment from 'moment';
import useTranslation from '@/i18n/useTransLation';
import { useGameIdListStore } from '@/stores/cansino/gameIdList';
import { useProfileSocket } from '@/socket/profile';
import { winAmount, setAmountZero } from '@/pages/casino/plinkoGame/utils/index';

interface columnsType {
    name: string,
    label: string,
    field: string,
    maxWidth: string,
    minWidth: string,
    hideStatusTextFrom?: number,
    showIconFrom: number
}

const ALL_MARK = 'ALL'; // 默认值，查询全部 
const iOneDayMS = 1000 * 60 * 60 * 24;
const iDaysAgo = iOneDayMS * 30; // 30天的长度

export default defineComponent({
    name: 'AccountHistory',
    components: {
        Popper,
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const accountHistoryActions = [{
            value: ALL_MARK,
            name: useTranslation().inAndOut,
        }, {
            value: 'deposit',
            name: useTranslation().deposit,
            icon: 'deposit-transfer-in',
            color: '#1bb83d', // 绿色
        }, {
            value: 'withdraw',
            name: useTranslation().withdraw,
            icon: 'deposit-transfer-out',
            color: 'rgba(251, 25, 73, 1)', // 红色 
        }];
        const oActions = accountHistoryActions.reduce((result, cur) => {
            result[cur.value] = cur;
            return result;
        }, {});
        const iNow = Date.Now();
        return {
            oActions,
            accountHistoryActions,
            gameIdListStore: useGameIdListStore(),
            t: useTranslation(),

            actionValue: ALL_MARK, // 当前选中的action
            datePicker: { from: moment(iNow - iDaysAgo), to: moment(iNow) }, // 时间区间
            params: {
                page: 1, // 页码
                action: '',
                dateFrom: iNow - iDaysAgo, // 默认 30 天之前的时间
                dateTo: iNow, // 默认当前时间
                totalCount: !!1,
            },
            historyData: { // 表格历史数据
                response: [],
                count: 0,
            },
            iRows: 20, // 常量，后端人员声明的，固定的每页行数
            moment: moment,
            windowWidth: 0,
            columns: [
                {
                    name: useTranslation().GameDetails.Date.toUpperCase(),
                    label: useTranslation().GameDetails.Date.toUpperCase(),
                    // 日期, 时间
                    field: 'date',
                    maxWidth: '10%',
                    minWidth: '10%',
                    showIconFrom: 537, // windowWidth <= 537是显示icon
                },
                {
                    name: useTranslation().Type.toUpperCase(),
                    label: useTranslation().Type.toUpperCase(),
                    // 类型
                    field: 'type',
                    maxWidth: '26%',
                    minWidth: '26%',
                },
                {
                    name: useTranslation().State.toUpperCase(),
                    label: useTranslation().State.toUpperCase(),
                    // 状态
                    field: 'state',
                    maxWidth: '30%',
                    minWidth: '30%',
                    hideStatusTextFrom: 631 // windowWidth <= 631是显示icon
                },
                {
                    name: useTranslation().Amount.toUpperCase(),
                    label: useTranslation().Amount.toUpperCase(),
                    // 数量
                    field: 'amounts',
                    maxWidth: '34%',
                    minWidth: '34%',
                }
            ] as Array<columnsType>
        }
    },
    computed: {
        localeLang() {
            return useI18n().locale.value;
        },
    },
    watch: {
        params: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.handleEmitGetHistory(newVal)
                }
            },
            deep: true,
        }
    },
    mounted() {
        this.windowWidth = document.body.clientWidth;
        window.addEventListener('resize', this.handleResize)
        this.initData();
        onUnmounted(() => {
            window.removeEventListener('resize', this.handleResize)
        })
    },
    methods: {
        winAmount,
        setAmountZero,
        /**
         * 格式化时间
         * @param param0 { from, to }
         * return { from, to }
         */
        formatDate({ from, to }) {
            // 取日期起点设为 00:00:00 终点是 23:59:59 
            return {
                from: moment(new Date(from)).startOf('day').valueOf(),
                to: moment(new Date(to)).endOf('day').valueOf(),
            }
        },
        /**
         * 数据初始化
         */
        initData() {
            this.actionValue = ALL_MARK;
            this.datePicker = {
                from: moment(new Date(this.params.dateFrom)),
                to: moment(new Date(this.params.dateTo)),
            }
            const { from, to } = this.formatDate({
                from: this.params.dateFrom,
                to: this.params.dateTo
            });
            this.params = {
                ...this.params,
                action: this.actionValue,
                dateFrom: from,
                dateTo: to,
            }
        },
        /**
         * 查询交易记录
         * @param params 请求参数
         */
        handleEmitGetHistory(params) {
            const { EMIT_ACCOUNT_HISTORY } = useProfileSocket();
            const oNewParams = deepCopy(params);
            if (oNewParams.action === ALL_MARK) {
                oNewParams.action = ''; // 有意传空，设为查所有 
            }
            EMIT_ACCOUNT_HISTORY(oNewParams, (res) => {
                import.meta.dev && console.log(`${oNewParams.action || 'All'} 记录查到 ↓\n`, deepCopy(res));
                Object.assign(this.historyData, res);
            });
        },
        /**
         * 切换action查询history
         * @param value action
         */
        handleSelectAction(value: string) {
            this.params.page = 1;
            this.params.action = value;
        },
        /**
         * 选择日期
         * @param value 
         */
        handleDatePicker(value) {
            // 如果value是字符串，则说明是选择同一天
            if (typeof value === 'string') {
                this.datePicker = {
                    from: moment(new Date(value)),
                    to: moment(new Date(value))
                };
            } else {
                this.datePicker = value;
            }
            this.params.page = 1;
            const { from: dateFrom, to: dateTo } = this.formatDate(this.datePicker);
            this.params = {
                ...this.params,
                dateFrom,
                dateTo
            }
        },
        handleResize() {
            this.windowWidth = document.body.clientWidth;
        },
        /**
         * 格式化日期为 YYYY/MM/DD格式
         * @param date 
         */
        formatNewDate(date) {
            const day = String(new Date(date).getDate()).padStart(2, '0');
            const month = String(new Date(date).getMonth() + 1).padStart(2, '0'); // 月份从0开始
            const year = new Date(date).getFullYear();
            if (useI18n().locale.value == 'cn') {
                return `${year}/${month}/${day}`;
            }
            return `${day}/${month}/${year}`;
        },
        handleHide() {
            this.$emit('update:show', false)
        },
    },
})
</script>

<style lang="scss" scoped>
.account-history {
    user-select: none;
    height: 100vh !important;
    max-height: 100vh !important;

    .history-select {
        display: flex;
        justify-content: flex-start;
        gap: 8px;

        .drop-down {
            width: auto;

            @media (max-width: 380px) {
                flex-grow: 1;
                min-width: 0;
            }
        }
    }

    .history-table {
        container-type: inline-size;
        margin: 0px 0 20px;

        .table-header {
            background: linear-gradient(180deg, #12161E 15.68%, #171D2B 86.68%);
            border-radius: 8px;
            color: rgba(147, 172, 211, 1);
            line-height: 3;
        }

        ul {
            li {
                align-items: center;
                display: flex;
                height: 50px;
                margin-top: 6px;
                padding-left: 10px;
            }
        }

        .item-game {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .item-date-th {
            opacity: 0;
        }

        .item-state-th {
            padding-left: 24px;
        }
    }

    .history-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 20px;

        :deep(.q-pagination) {
            button {
                background: #545c6c40;
                color: #55657e;
                border-radius: 10px;
                font-size: 14px;
                font-weight: 600;
                height: 35px;
                min-width: 35px !important;
                margin: 0 2px;
            }

            .q-btn--standard {
                background: #2281f6;
                font-size: 15px;
            }
        }
    }
}

.state-span {
    display: inline;
    font-size: 14px;
    font-weight: 600;
    height: 20px;
    letter-spacing: -.28px;
    line-height: 20px;

    svg {
        fill: #1bb83d;
        font-size: 24px;
        width: 24px;
        height: 24px;
    }
}

.plus-mark {
    &:before {
        content: '+';
    }
}

.game-dialog {
    display: block;
}

:deep(.q-dialog__inner--minimized) {
    padding: 0px;
}
</style>
